import { advancedReducer } from '../../filters/components/advanced/reducer';
import { accessSystemReducer } from '../../filters/state/advanced/access_system';
import { advancedApplyReducer } from '../../filters/state/advanced/apply';
import { areaReducer } from '../../filters/state/advanced/area';
import { balconiesReducer } from '../../filters/state/advanced/balconies';
import { bboxReducer } from '../../filters/state/advanced/bbox';
import { bedroomsReducer } from '../../filters/state/advanced/bedrooms_min_count';
import { buildingClassTypeReducer } from '../../filters/state/advanced/building_class';
import { warehouseBuildingClassTypeReducer } from '../../filters/state/advanced/building_class_warehouse';
import { buildingConditionTypeReducer } from '../../filters/state/advanced/building_condition';
import { buildingCraneTypeReducer } from '../../filters/state/advanced/building_crane';
import { buildingElevatorTypeReducer } from '../../filters/state/advanced/building_elevator';
import { buildingGatesTypeReducer } from '../../filters/state/advanced/building_gates';
import { buildingHeatingTypeReducer } from '../../filters/state/advanced/building_heating';
import { buildingTypeReducer } from '../../filters/state/advanced/building_type';
import { ceilingHeightReducer } from '../../filters/state/advanced/ceiling_height';
import { comissionReducer } from '../../filters/state/advanced/comission';
import { decorationTypeReducer } from '../../filters/state/advanced/decoration';
import { developerTypeReducer } from '../../filters/state/advanced/developer';
import { doneYearReducer } from '../../filters/state/advanced/done_year';
import { dwellingStatusReducer } from '../../filters/state/advanced/dwelling_status';
import { elevatorsReducer } from '../../filters/state/advanced/elevators';
import { entranceTypeReducer } from '../../filters/state/advanced/entrance';
import { facilitiesReducer } from '../../filters/state/advanced/facilities';
import { floorReducer } from '../../filters/state/advanced/floor';
import { floorsTotalReducer } from '../../filters/state/advanced/floors_total';
import { fromMKADReducer } from '../../filters/state/advanced/from_mkad';
import { garageKindReducer } from '../../filters/state/advanced/garage_kind';
import { garageMaterialReducer } from '../../filters/state/advanced/garage_material';
import { garageStatusReducer } from '../../filters/state/advanced/garage_status';
import { garageTypeReducer } from '../../filters/state/advanced/garage_type';
import { heatingReducer } from '../../filters/state/advanced/heating';
import { houseMaterialReducer } from '../../filters/state/advanced/house_material';
import { houseYearReducer } from '../../filters/state/advanced/house_year';
import { infrastructureReducer } from '../../filters/state/advanced/infrastructure';
import { landStatusReducer } from '../../filters/state/advanced/land_status';
import { layoutTypeReducer } from '../../filters/state/advanced/layout';
import { manufactureConditionTypeReducer } from '../../filters/state/advanced/manufacture_condition';
import { offerIdReducer } from '../../filters/state/advanced/offer_id';
import { officeConditionTypeReducer } from '../../filters/state/advanced/office_condition';
import { parkingReducer } from '../../filters/state/advanced/parking';
import { phoneReducer } from '../../filters/state/advanced/phone';
import { propertyTypeReducer } from '../../filters/state/advanced/property_type';
import { publishPeriodReducer } from '../../filters/state/advanced/publish_period';
import { rentTermsReducer } from '../../filters/state/advanced/rent_terms';
import { rentTimeReducer } from '../../filters/state/advanced/rent_time';
import { repairReducer } from '../../filters/state/advanced/repair';
import { roomsInDealReducer } from '../../filters/state/advanced/rooms_in_deal';
import { roomsTotalReducer } from '../../filters/state/advanced/rooms_total';
import { saleTypeReducer } from '../../filters/state/advanced/sale_type';
import { commercialSpecialtyTypesReducer } from '../../filters/state/advanced/specialty_types';
import { suburbanUtilitiesReducer } from '../../filters/state/advanced/suburban_utilities';
import { suburbanWCReducer } from '../../filters/state/advanced/suburban_wc';
import { tenantsReducer } from '../../filters/state/advanced/tenants';
import { advancedTermReducer } from '../../filters/state/advanced/term';
import { advancedTermsReducer } from '../../filters/state/advanced/terms';
import { toggleAdvancedModalReducer } from '../../filters/state/advanced/toggle_modal';
import { wcReducer } from '../../filters/state/advanced/wc';
import { windowsTypeReducer } from '../../filters/state/advanced/windows';
import { wordsExcludeReducer } from '../../filters/state/advanced/words_exclude';
import { wordsIncludeReducer } from '../../filters/state/advanced/words_include';
import { bsCenterReducer } from '../../filters/state/bs_center';
import { currencyTypeReducer } from '../../filters/state/currency_type';
import { dealTypeReducer } from '../../filters/state/deal_type';
import { directionsModalReducer } from '../../filters/state/directions';
import { toggleDistrictsModalReducer } from '../../filters/state/districts/popup';
import { saveDistrictsModalReducer } from '../../filters/state/districts/popup_save';
import { domrfReducer } from '../../filters/state/domrf';
import { dealRentReducer } from '../../filters/state/is_deal_rent';
import { favoriteReducer } from '../../filters/state/favorite';
import { geoSuggestReducer } from '../../filters/state/geo';
import { hiddenBaseSearchReducer } from '../../filters/state/hidden_base_search';
import { jsonQueryPriceTypeReducer } from '../../filters/state/json_query_price_type';
import { kpIdReducer } from '../../filters/state/kp_id';
import {
  locationSwitcherAutocompleteReducer,
  locationSwitcherPopupReducer,
  locationSwitcherReducer,
} from '../../filters/state/location_switcher';
import { deleteAreaReducer } from '../../filters/state/map/area_delete';
import { changeMapReducer } from '../../filters/state/map/map_changed';
import { saveMapModalReducer } from '../../filters/state/map/save_modal';
import { toggleMapModalReducer } from '../../filters/state/map/toggle_modal';
import { metaReducer } from '../../filters/state/meta';
import { metroSelectionReducer } from '../../filters/state/metro/changed';
import { saveMetroModalReducer } from '../../filters/state/metro/save_modal';
import { toggleMetroModalReducer } from '../../filters/state/metro/toggle_modal';
import { multiIdReducer } from '../../filters/state/multi_id';
import { offerTypeReducer } from '../../filters/state/offer_type';
import { paginationReducer } from '../../filters/state/pagination';
import { priceReducer } from '../../filters/state/price';
import { priceTypeReducer } from '../../filters/state/price_type';
import { roomReducer } from '../../filters/state/room';
import { searchReducer } from '../../filters/state/search';
import { sortReducer } from '../../filters/state/sort';
import { subscribeReducer } from '../../filters/state/subscribings/serp_subscribe';
import { tagsReducer } from '../../filters/state/tags';
import { fitTagsInOneLineReducer } from '../../filters/state/tags/fit_tags_in_one_line';
import { undergroundTravelReducer } from '../../filters/state/underground_travel';
import { userIdReducer } from '../../filters/state/user_id';
import { withPhotoReducer } from '../../filters/state/with_photo';
import { signInTriggerModal } from '../../registrationTriggers/signInPopup/reducers/signInTriggerModal';
import { showMotivationPopupReducer } from '../../serp/state/login_motivation_popup';
import { newbuildingInfoReducer } from '../../serp/state/newbuilding_info';
import { agentRatingReducer } from '../../serp/state/offer_card/agent';
import { offerCommentsReducer } from '../../serp/state/offer_card/comments';
import { offerComplaintsReducer } from '../../serp/state/offer_card/complaints';
import { simplifiedOfferCardPopupsStateReducer } from '../../serp/state/offer_card/simplified_card_popups';
import { toggleOfficeCalculatorReducer } from '../../serp/state/office_calculator';
import { offersPrintReducer } from '../../serp/state/print';
import { pushSubscribedReducer } from '../../serp/state/push_subscribed';
import { suggestionsDistancesReducer } from '../../serp/state/suggestions';
import { hideOfferReducer } from '../../serp/state/hide_offer';
import { IAppStore } from './store';
import { complaintFeedbackReducer } from '../../serp/state/offer_card/feedback_complaint';
import { suburbanOfferFilterReducer } from '../../filters/state/suburban_offer_filter';
import { withNeighborsReducer } from '../../filters/state/with_neighbors';
import { withLayoutReducer } from '../../filters/state/with_layout';
import { verifyPhoneSerpReducer } from '@cian/sms-validation-widget';
import { demandSerpReducer } from '@cian/demand-trap-widget';
import { identicalOffersIdReducer } from '../../filters/state/identical_offers_id';
import { commercialSurveyWidgetModal } from '../../serp/state/commecial_survey';
import { newbuildingConsultant } from '../../serp/state/newbuildingConsultant';
import { coworkingOfferTypeReducer } from '../../filters/state/coworking_offer_type';
import { amenityReducer } from '../../filters/state/amenity';
import { coworkingAccessReducer } from '../../filters/state/advanced/coworking_access';
import { workPlaceCountReducer } from '../../filters/state/workplace_count';
import { newbuildingHouseReducer } from '../../filters/state/newbuilding_house';
import { changeJsonQueryReducer } from '../../filters/state/json_query';
import { favoritesAssignReducer } from '../../reducers/favoritesAssign';
import { coworkingIdReducer } from '../../filters/state/coworking_id';
import { coworkingExperimentsReducer } from '../../serp/state/coworking_experiments';
import { isByCommercialOwnerReducer } from '../../filters/state/is_by_commercial_owner';

export function attachReducers(store: IAppStore) {
  store.addReducer(verifyPhoneSerpReducer);
  store.addReducer(demandSerpReducer);
  store.addReducer(accessSystemReducer);
  store.addReducer(advancedApplyReducer);
  store.addReducer(advancedTermReducer);
  store.addReducer(advancedTermsReducer);
  store.addReducer(agentRatingReducer);
  store.addReducer(areaReducer);
  store.addReducer(balconiesReducer);
  store.addReducer(bboxReducer);
  store.addReducer(bedroomsReducer);
  store.addReducer(newbuildingHouseReducer);
  store.addReducer(bsCenterReducer);
  store.addReducer(buildingClassTypeReducer);
  store.addReducer(buildingConditionTypeReducer);
  store.addReducer(buildingCraneTypeReducer);
  store.addReducer(buildingElevatorTypeReducer);
  store.addReducer(buildingGatesTypeReducer);
  store.addReducer(buildingHeatingTypeReducer);
  store.addReducer(buildingTypeReducer);
  store.addReducer(ceilingHeightReducer);
  store.addReducer(changeMapReducer);
  store.addReducer(comissionReducer);
  store.addReducer(commercialSpecialtyTypesReducer);
  store.addReducer(currencyTypeReducer);
  store.addReducer(dealTypeReducer);
  store.addReducer(decorationTypeReducer);
  store.addReducer(deleteAreaReducer);
  store.addReducer(developerTypeReducer);
  store.addReducer(directionsModalReducer);
  store.addReducer(domrfReducer);
  store.addReducer(dealRentReducer);
  store.addReducer(doneYearReducer);
  store.addReducer(dwellingStatusReducer);
  store.addReducer(elevatorsReducer);
  store.addReducer(entranceTypeReducer);
  store.addReducer(facilitiesReducer);
  store.addReducer(favoriteReducer);
  store.addReducer(fitTagsInOneLineReducer);
  store.addReducer(floorReducer);
  store.addReducer(floorsTotalReducer);
  store.addReducer(fromMKADReducer);
  store.addReducer(garageKindReducer);
  store.addReducer(garageMaterialReducer);
  store.addReducer(garageStatusReducer);
  store.addReducer(garageTypeReducer);
  store.addReducer(geoSuggestReducer);
  store.addReducer(heatingReducer);
  store.addReducer(hiddenBaseSearchReducer);
  store.addReducer(houseMaterialReducer);
  store.addReducer(houseYearReducer);
  store.addReducer(infrastructureReducer);
  store.addReducer(suburbanOfferFilterReducer);
  store.addReducer(kpIdReducer);
  store.addReducer(landStatusReducer);
  store.addReducer(layoutTypeReducer);
  store.addReducer(locationSwitcherAutocompleteReducer);
  store.addReducer(locationSwitcherPopupReducer);
  store.addReducer(locationSwitcherReducer);
  store.addReducer(manufactureConditionTypeReducer);
  store.addReducer(metaReducer);
  store.addReducer(metroSelectionReducer);
  store.addReducer(multiIdReducer);
  store.addReducer(newbuildingInfoReducer);
  store.addReducer(offerCommentsReducer);
  store.addReducer(offerComplaintsReducer);
  store.addReducer(offerIdReducer);
  store.addReducer(offerTypeReducer);
  store.addReducer(offersPrintReducer);
  store.addReducer(officeConditionTypeReducer);
  store.addReducer(paginationReducer);
  store.addReducer(parkingReducer);
  store.addReducer(phoneReducer);
  store.addReducer(priceReducer);
  store.addReducer(priceTypeReducer);
  store.addReducer(jsonQueryPriceTypeReducer);
  store.addReducer(propertyTypeReducer);
  store.addReducer(publishPeriodReducer);
  store.addReducer(rentTermsReducer);
  store.addReducer(rentTimeReducer);
  store.addReducer(repairReducer);
  store.addReducer(roomReducer);
  store.addReducer(roomsInDealReducer);
  store.addReducer(roomsTotalReducer);
  store.addReducer(saleTypeReducer);
  store.addReducer(saveDistrictsModalReducer);
  store.addReducer(saveMapModalReducer);
  store.addReducer(saveMetroModalReducer);
  store.addReducer(searchReducer);
  store.addReducer(showMotivationPopupReducer);
  store.addReducer(signInTriggerModal);
  store.addReducer(simplifiedOfferCardPopupsStateReducer);
  store.addReducer(sortReducer);
  store.addReducer(subscribeReducer);
  store.addReducer(suburbanUtilitiesReducer);
  store.addReducer(suburbanWCReducer);
  store.addReducer(suggestionsDistancesReducer);
  store.addReducer(hideOfferReducer);
  store.addReducer(tenantsReducer);
  store.addReducer(toggleAdvancedModalReducer);
  store.addReducer(toggleDistrictsModalReducer);
  store.addReducer(toggleMapModalReducer);
  store.addReducer(toggleMetroModalReducer);
  store.addReducer(toggleOfficeCalculatorReducer);
  store.addReducer(undergroundTravelReducer);
  store.addReducer(userIdReducer);
  store.addReducer(warehouseBuildingClassTypeReducer);
  store.addReducer(wcReducer);
  store.addReducer(windowsTypeReducer);
  store.addReducer(withPhotoReducer);
  store.addReducer(withNeighborsReducer);
  store.addReducer(withLayoutReducer);
  store.addReducer(wordsExcludeReducer);
  store.addReducer(wordsIncludeReducer);
  store.addReducer(pushSubscribedReducer);
  store.addReducer(complaintFeedbackReducer);
  store.addReducer(identicalOffersIdReducer);
  store.addReducer(commercialSurveyWidgetModal);
  store.addReducer(newbuildingConsultant);
  store.addReducer(coworkingOfferTypeReducer);
  store.addReducer(amenityReducer);
  store.addReducer(coworkingAccessReducer);
  store.addReducer(workPlaceCountReducer);
  store.addReducer(changeJsonQueryReducer);
  store.addReducer(favoritesAssignReducer);
  store.addReducer(coworkingIdReducer);
  store.addReducer(coworkingExperimentsReducer);
  store.addReducer(isByCommercialOwnerReducer);

  /*
   * Алексей, Максим, другой Алексей, Слава, Илья или кто-либо другой, пожалуйста,
   * не трогайте этот Reducer, он всегда должен быть в конце ;(
   */
  store.addReducer(advancedReducer);
  store.addReducer(tagsReducer);
}
